import { render } from "./LogoutByNoti.vue?vue&type=template&id=982f3c82&scoped=true"
import script from "./LogoutByNoti.vue?vue&type=script&lang=js"
export * from "./LogoutByNoti.vue?vue&type=script&lang=js"

import "./LogoutByNoti.vue?vue&type=style&index=0&id=982f3c82&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-982f3c82"]])

export default __exports__